import "../css/supportfooter.css";

export default function Support() {
    return (
        <div className="support-footer-center-button-container">
                <div className="support-footer-intro">
                    Like our initiative?
                </div>
                <div className="support-footer-primary-button-container">
                    <a href="/donate">
                        <button className="support-footer-primary-button">Support Us</button>
                    </a>
                </div>
        </div>
    );
}